var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"APPOINTMENT-LIST-PLACEHOLDER"},[_c('span',{staticClass:"c-gray70 p-b-4 MESSAGE",attrs:{"selenium":"agenda-empty-notice"}},[_vm._v("\n    You have no customer appointments to show. Reach out and schedule one today!\n  ")]),_c('img',{attrs:{"alt":"appointments","src":require("./assets/emptystate_calendar.svg")}})])
}]

export { render, staticRenderFns }